"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAutoButton = void 0;
var react_1 = __importDefault(require("react"));
var SelectAutoButton_module_scss_1 = __importDefault(require("./SelectAutoButton.module.scss"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var selectors_1 = require("../../redux/selectors");
var SelectAutoButton = function (_a) {
    var register = _a.register, isError = _a.isError;
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectCar = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect;
    var selectButtonHandler = function () {
        dispatch((0, modalSlice_1.openModal)('selectCar'));
    };
    var getButtonValue = function () {
        var _a;
        if (selectCar === null || selectCar === void 0 ? void 0 : selectCar.brand) {
            var brandName = typeof selectCar.brand === 'string' ? selectCar.brand : selectCar.brand.name;
            return "".concat(brandName, " ").concat(((_a = selectCar === null || selectCar === void 0 ? void 0 : selectCar.model) === null || _a === void 0 ? void 0 : _a.name) || 'Неизвестная модель', " ").concat((selectCar === null || selectCar === void 0 ? void 0 : selectCar.year) || '');
        }
        return 'Выбрать автомобиль';
    };
    return (react_1.default.createElement("input", __assign({}, register, { className: "".concat(SelectAutoButton_module_scss_1.default.select_auto_button, " ").concat(!(selectCar === null || selectCar === void 0 ? void 0 : selectCar.brand) && isError ? 'field_error' : ''), type: "button", value: getButtonValue(), onClick: selectButtonHandler })));
};
exports.SelectAutoButton = SelectAutoButton;
